import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { BasicChip } from '@/components/Chips/BasicChip';

import { confirmSubmitModalStyles as sx } from './ConfirmSubmitModal/ConfirmSubmitModal.styles';
import { dcrReviewStyles } from './DcrReviewFooter/DcrReviewFooter.styles';

type Props = {
	label?: string;
	action: 'added' | 'removed';
	value: string;
	chip?: string | string[];
	asGridRow?: boolean;
};

export const WholeEntityChange = ({
	label,
	action,
	value,
	chip,
	asGridRow = false
}: Props) => {
	const { t } = useTranslation();
	const isAdded = action === 'added';
	const chips = (Array.isArray(chip) ? chip : [chip]).filter(
		(c): c is string => !!c
	);

	return (
		<Stack spacing={0.5} sx={asGridRow ? sx.gridContents : undefined}>
			{label && (
				<Typography sx={dcrReviewStyles.changeLabel}>{label}</Typography>
			)}
			<Box sx={asGridRow ? sx.gridContents : sx.changeRow}>
				<Typography
					component='span'
					variant='body2'
					sx={[sx.tag, isAdded ? sx.addedTag : sx.removedTag]}
				>
					{isAdded ? t('Added') : t('Removed')}
				</Typography>
				<Box sx={sx.valueColumn}>
					<Typography
						component='span'
						variant='body2'
						sx={isAdded ? sx.newValue : sx.removedValue}
					>
						{value}
					</Typography>
					{chips.length > 0 && (
						<Box sx={sx.wholeEntityChipRow}>
							{chips.map(c => (
								<BasicChip
									key={c}
									label={c}
									variant='basic'
									customSx={sx.wholeEntityChip}
								/>
							))}
						</Box>
					)}
				</Box>
			</Box>
		</Stack>
	);
};
